module.exports = __webpack_public_path__ + "img/DSC_0084.82f8914b.jpg";